import React from 'react';
import { trackCtaClick, BaseButton, useT } from '@repo/common';
import { HOME_V2_IMAGES } from './homeV2Assets';
import { IS_LEGACY_DOMAIN } from '../../../utils/brand.js';

const BRAND_NAME = IS_LEGACY_DOMAIN ? 'O!ng' : 'Koready';
const BRAND_NAME_FULL = IS_LEGACY_DOMAIN ? 'O!ng Lab' : 'Koready';
const OKOREAN_URL = 'https://skills.ko-ready.com/';

const trackCreatorCta = (buttonName) => {
  trackCtaClick({
    button_name: buttonName,
    section: 'creator_section',
    page_path: window.location.pathname,
  });
};

const BeACreator = () => {
  const t = useT();
  return (
    <section className='bg-bg-twodays px-4 pb-[100px] pt-0 mobile:pt-[60px] tabletH:px-6 tabletH:pt-[60px] tabletV:px-10 tabletV:pb-[140px] tabletV:pt-20 desktopL:px-20 desktopL:pb-[180px] desktopL:pt-[100px] desktopXXL:pt-[120px]'>
      <div className='mx-auto flex w-full max-w-[300px] flex-col items-center tabletH:max-w-[536px] tabletH:flex-row tabletH:items-center tabletH:gap-6 tabletV:max-w-[720px] tabletV:gap-10 desktopL:max-w-[840px] desktopL:gap-[60px] desktopXXL:max-w-[1160px] desktopXXL:gap-20'>
        <div className='order-1 flex w-full flex-col items-center justify-center pb-10 mobile:pb-[50px] tabletH:order-2 tabletH:min-w-0 tabletH:flex-1 tabletH:items-start tabletH:pb-0'>
          <div className='flex w-full flex-col items-center tabletH:hidden'>
            <h2 className='w-full pb-2 text-center text-[20px] font-medium leading-[1.2] text-text-primary'>
              {t(
                `Be an Creator at ${BRAND_NAME}`,
                `${BRAND_NAME} 크리에이터 되기`,
              )}
            </h2>

            <div className='w-full pb-4 text-center text-[12px] font-normal leading-[1.4] text-text-placeholder mobile:pb-6'>
              <p>{t('The ultimate platform for Korea experts.')}</p>
              <p>
                {t(
                  'Teach, guide, and earn by sharing everything you know about Korea.',
                )}
              </p>
            </div>

            <BaseButton
              type='text_basic'
              size='m'
              rounded='pill'
              hideIcon
              onClick={() => trackCreatorCta('contact_us')}
              className='w-[160px] mobile:w-[180px]'
            >
              {t('Contact Us')}
            </BaseButton>
          </div>

          <div className='hidden w-full tabletH:block'>
            <h2 className='pb-3 text-[18px] font-medium leading-[1.5] text-text-primary tabletV:pb-4 tabletV:text-[24px] tabletV:leading-[1.2] desktopL:pb-6 desktopL:text-[28px] desktopXXL:text-[38px]'>
              {t(
                `Be a Creator at ${BRAND_NAME}`,
                `${BRAND_NAME} 크리에이터 되기`,
              )}
            </h2>

            <div className='pb-5 text-[12px] font-normal leading-[1.4] text-text-placeholder tabletV:pb-6 tabletV:text-[14px] tabletV:font-medium desktopL:pb-10 desktopL:text-[16px] desktopXXL:text-[20px] desktopXXL:leading-[1.5]'>
              <p>
                <span>{t('Got an idea? - ', '아이디어가 있으신가요? — ')}</span>
                <span className='text-green-deep03'>
                  {t('We have the canvas.')}
                </span>
              </p>
              <p>
                {t(
                  `Transform your personal and professional experiences into engaging content. Partner with ${BRAND_NAME_FULL}`,
                  `개인적·직업적 경험을 매력적인 콘텐츠로 만들어 보세요. ${BRAND_NAME_FULL}와 함께하세요.`,
                )}
              </p>
            </div>

            <div className='w-full tabletV:hidden'>
              <BaseButton
                as='a'
                href={OKOREAN_URL}
                type='text_basic'
                size='m'
                rounded='pill'
                hideIcon
                onClick={() => trackCreatorCta('start_with_koready')}
                width='100%'
                textWrapperClass='flex items-center justify-center text-center'
                className='text-center'
              >
                {t('Start free')}
              </BaseButton>
            </div>

            <div className='hidden w-full tabletV:block desktopL:hidden'>
              <BaseButton
                as='a'
                href={OKOREAN_URL}
                type='text_basic'
                size='l'
                rounded='pill'
                hideIcon
                onClick={() => trackCreatorCta('start_with_koready')}
                width='100%'
                textWrapperClass='flex items-center justify-center text-center'
                className='text-center'
              >
                {t('Start free')}
              </BaseButton>
            </div>

            <div className='hidden w-full desktopL:block'>
              <BaseButton
                as='a'
                href={OKOREAN_URL}
                type='text_basic'
                size='xl'
                rounded='pill'
                hideIcon
                onClick={() => trackCreatorCta('start_with_koready')}
                width='100%'
                textWrapperClass='flex items-center justify-center text-center'
                className='text-center'
              >
                {t('Start free')}
              </BaseButton>
            </div>
          </div>
        </div>

        <div className='order-2 flex w-full shrink-0 justify-center tabletH:order-1 tabletH:w-[260px] tabletV:w-[360px] desktopL:w-[403px] desktopXXL:w-[613px]'>
          <img
            src={HOME_V2_IMAGES.creator}
            alt={`Be a Creator at ${BRAND_NAME}`}
            className='h-auto w-[268px] max-w-none tabletH:w-full'
          />
        </div>
      </div>
    </section>
  );
};

export default BeACreator;
